import React from 'react'

import OtpInput from 'react-otp-input'

import styles from './styles.module.css'

const OtpInputComp = ({ ...props }) => {
  return (
    <OtpInput
      containerStyle={styles.otp_container}
      inputStyle={styles.otp_inp}
      focusStyle={styles.inp_focus}
      shouldAutoFocus={true}
      isInputNum={true}
      {...props}
    />
  )
}

export default OtpInputComp
